module.exports = __webpack_public_path__ + "static/img/51.5cfa0728.png";